/**
 * @file index.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Get all images from one site make the app standard and simple.
 */
export const images = {
  loginBg: require("./images/User-cover.jpg"),
  loginCandidateBg: require("./images/Cover.png")
};
